"use strict";var t=require("luxon");exports.DateInfo=class{static months(e,s){return t.Info.months(e,s)}static weekdays(e,s){return t.Info.weekdays(e,s)}};
//# sourceMappingURL=DateInfo.js.map
